import React, { useState } from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Timer, TrendingUp, Flame, BookOpen, GraduationCap, Crown, Star, Smartphone, Sparkles } from 'lucide-react';
import { OfferCountdown } from '../ui/OfferCountdown';
type PlanId = 'ninos' | 'adolescentes' | 'premium';
const plans: Record<PlanId, {
  id: PlanId;
  name: string;
  description: string;
  icon: any;
  price: string;
  originalPrice: string;
  savings: string;
  checkoutUrl: string;
  recommended?: boolean;
}> = {
  ninos: {
    id: 'ninos',
    name: 'Piano para Niños',
    description: 'Método completo para los más chicos',
    icon: BookOpen,
    price: '19.990',
    originalPrice: '34.990',
    savings: '15.000',
    checkoutUrl: 'https://checkout.tusbeneficios.shop/cart/51136513147113:1'
  },
  adolescentes: {
    id: 'adolescentes',
    name: 'Piano para Adolescentes',
    description: 'Método completo para adolescentes',
    icon: GraduationCap,
    price: '19.990',
    originalPrice: '34.990',
    savings: '15.000',
    checkoutUrl: 'https://checkout.tusbeneficios.shop/cart/51136513179881:1'
  },
  premium: {
    id: 'premium',
    name: 'Piano PRO — Niños + Adolescentes + PREMIUM',
    description: 'Los 8 tomos completos + bonos exclusivos',
    icon: Crown,
    price: '28.990',
    originalPrice: '49.990',
    savings: '21.000',
    checkoutUrl: 'https://checkout.tusbeneficios.shop/cart/51136514490601:1',
    recommended: true
  }
};
export function Offer() {
  const [selectedPlan, setSelectedPlan] = useState<PlanId>('premium');
  const current = plans[selectedPlan];
  return <section id="oferta" className="py-24 bg-navy-light scroll-mt-10 relative overflow-hidden" data-id="element-136">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[400px] bg-gold/10 rounded-full blur-3xl pointer-events-none" data-id="element-137"></div>

      <div className="container mx-auto px-4 max-w-3xl relative z-10" data-id="element-138">
        {/* Urgency block */}
        <FadeIn data-id="element-139">
          <div className="mb-8 text-center" data-id="element-140">
            <div className="inline-flex items-center gap-2 bg-red-500/15 border border-red-500/40 text-red-300 px-4 py-1.5 rounded-full text-xs md:text-sm font-bold uppercase tracking-wider mb-5" data-id="element-141">
              <Flame className="w-4 h-4" data-id="element-142" />
              La oferta cierra en
            </div>
            <OfferCountdown data-id="element-143" />
            <p className="text-beige/90 text-base md:text-lg font-semibold mt-5 max-w-xl mx-auto" data-id="element-144">
              Después sube <span className="text-red-400" data-id="element-145">$8.000 ARS</span> y{' '}
              <span className="underline decoration-red-400/50" data-id="element-146">
                no vuelve a bajar
              </span>
              .
            </p>

            {/* Cupos progress */}
            <div className="max-w-md mx-auto mt-6 bg-navy border border-gold/20 rounded-2xl p-4" data-id="element-147">
              <div className="flex items-center justify-between mb-2 text-sm" data-id="element-148">
                <span className="text-beige/80 flex items-center gap-1.5" data-id="element-149">
                  <TrendingUp className="w-4 h-4 text-gold" data-id="element-150" />
                  Cupos al precio de lanzamiento
                </span>
                <span className="text-gold font-bold" data-id="element-151">68% tomados</span>
              </div>
              <div className="w-full h-2.5 bg-navy-lighter rounded-full overflow-hidden" data-id="element-152">
                <div className="h-full bg-gradient-to-r from-gold to-gold-light rounded-full transition-all duration-1000" style={{
                width: '68%'
              }} data-id="element-153"></div>
              </div>
            </div>
          </div>
        </FadeIn>

        {/* Main offer card */}
        <FadeIn delay={0.1} data-id="element-154">
          <div className="bg-navy border border-gold/30 rounded-3xl p-6 md:p-10 relative shadow-[0_0_60px_rgba(212,168,90,0.15)]" data-id="element-155">
            <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-gold text-navy px-6 py-2 rounded-full font-black flex items-center gap-2 shadow-lg w-max text-sm md:text-base uppercase tracking-wide" data-id="element-156">
              <Timer className="w-5 h-5" data-id="element-157" />
              Oferta por tiempo limitado
            </div>

            <h2 className="text-2xl md:text-4xl font-black text-beige text-center mb-2 mt-4" data-id="element-158">
              Elegí tu <span className="text-gold" data-id="element-159">plan ideal</span>
            </h2>
            <p className="text-center text-beige/60 mb-8 text-sm md:text-base" data-id="element-160">
              Acceso inmediato · de por vida · desde cualquier dispositivo
            </p>

            {/* Plan options */}
            <div className="space-y-3 mb-6" data-id="element-161">
              {(Object.values(plans) as (typeof plans)[PlanId][]).map(plan => {
              const Icon = plan.icon;
              const isSelected = selectedPlan === plan.id;
              const isPremium = plan.recommended;
              return <button key={plan.id} type="button" onClick={() => setSelectedPlan(plan.id)} className={`w-full text-left rounded-2xl p-4 md:p-5 transition-all border-2 ${isSelected ? isPremium ? 'bg-gold/5 border-gold shadow-[0_0_30px_rgba(212,168,90,0.4)]' : 'bg-gold/5 border-gold/70 shadow-[0_0_20px_rgba(212,168,90,0.2)]' : isPremium ? 'bg-navy-lighter border-gold/40 hover:border-gold/70' : 'bg-navy-lighter border-beige/10 hover:border-beige/25'}`} data-id="element-162">
                      <div className="flex items-start gap-3 md:gap-4" data-id="element-163">
                        {/* Radio */}
                        <div className={`mt-1 w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${isSelected ? 'border-gold' : 'border-beige/30'}`} data-id="element-164">
                          {isSelected && <div className="w-2.5 h-2.5 rounded-full bg-gold" data-id="element-165"></div>}
                        </div>

                        <div className="flex-1 min-w-0" data-id="element-166">
                          <div className="flex flex-wrap items-start justify-between gap-3 mb-1" data-id="element-167">
                            <div className="flex items-center gap-2" data-id="element-168">
                              <Icon className={`w-5 h-5 flex-shrink-0 ${isPremium ? 'text-gold' : 'text-beige/70'}`} data-id="element-169" />
                              <h3 className="font-black text-beige text-sm md:text-base uppercase tracking-wide leading-tight" data-id="element-170">
                                {plan.name}
                              </h3>
                            </div>
                            <div className="text-right flex-shrink-0" data-id="element-171">
                              <p className="text-xs md:text-sm text-beige/40 line-through" data-id="element-172">
                                ${plan.originalPrice}
                              </p>
                              <p className={`text-xl md:text-2xl font-black ${isPremium ? 'text-gold' : 'text-beige'}`} data-id="element-173">
                                ${plan.price}
                              </p>
                            </div>
                          </div>

                          {isPremium && <div className="flex flex-wrap gap-2 mb-2" data-id="element-174">
                              <span className="inline-flex items-center gap-1 bg-gold text-navy text-[10px] md:text-xs font-black px-2.5 py-1 rounded-md uppercase tracking-wider" data-id="element-175">
                                <Star className="w-3 h-3 fill-navy" data-id="element-176" />
                                Más elegido
                              </span>
                              <span className="inline-flex items-center bg-green-500/20 border border-green-500/40 text-green-300 text-[10px] md:text-xs font-black px-2.5 py-1 rounded-md uppercase tracking-wider" data-id="element-177">
                                Ahorrás ${plan.savings}
                              </span>
                            </div>}

                          <p className="text-xs md:text-sm text-beige/60" data-id="element-178">
                            {plan.description}
                          </p>
                        </div>
                      </div>
                    </button>;
            })}
            </div>

            {/* CTA */}
            <a href={current.checkoutUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center w-full bg-gold hover:bg-gold-hover text-navy font-black text-base md:text-xl py-5 px-6 rounded-2xl transition-all duration-300 transform hover:scale-[1.02] hover:shadow-[0_10px_40px_rgba(212,168,90,0.5)] mb-4 uppercase tracking-wide shadow-[0_8px_30px_rgba(212,168,90,0.3)]" data-id="element-179">
              <span className="flex items-center gap-2" data-id="element-180">
                SÍ, QUIERO {current.name.toUpperCase()}
                <span aria-hidden data-id="element-181">→</span>
              </span>
            </a>

            <p className="text-center text-sm text-beige/50 italic mb-6" data-id="element-182">
              {current.recommended ? 'La opción más elegida — máximo nivel de aprendizaje' : 'Empezá tu camino musical hoy mismo'}
            </p>

            <div className="border-t border-beige/10 pt-5" data-id="element-183">
              <div className="flex flex-col items-center gap-1 text-beige/70 font-medium" data-id="element-184">
                <div className="flex items-center gap-2" data-id="element-185">
                  <Smartphone className="w-5 h-5 text-gold" data-id="element-186" />
                  <p className="text-sm md:text-base" data-id="element-187">
                    Acceso inmediato desde cualquier dispositivo
                  </p>
                </div>
                <p className="text-xs md:text-sm text-beige/50" data-id="element-188">
                  Empezás hoy mismo
                </p>
              </div>
            </div>
          </div>
        </FadeIn>

        {/* PREMIUM BONUSES */}
        <FadeIn delay={0.2} data-id="element-189">
          <div className="mt-8 bg-navy border-2 border-gold/40 rounded-3xl p-6 md:p-10 shadow-[0_0_40px_rgba(212,168,90,0.15)] relative overflow-hidden" data-id="element-190">
            <h3 className="text-2xl md:text-3xl font-black text-beige text-center mb-2" data-id="element-191">
              Qué vas a obtener con <span className="text-gold" data-id="element-192">PREMIUM</span>
            </h3>
            <p className="text-center text-beige/60 mb-8 text-sm md:text-base max-w-xl mx-auto" data-id="element-193">
              Bonos exclusivos que solo recibís al elegir el plan completo
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-194">
              {[{
              title: 'Repertorio Expandido',
              description: 'Una biblioteca extra de canciones desbloqueada con clásicos, modernos y favoritos para tocar al instante.',
              icon: BookOpen
            }, {
              title: 'Plan de Progreso 90 días',
              description: 'Cronograma guiado con objetivos semanales, ejercicios y metas medibles para avanzar sin perder el ritmo.',
              icon: Timer
            }, {
              title: 'Diccionario Musical del Pianista',
              description: 'Glosario práctico con cada término esencial para que nunca te quedes con dudas mientras tocás.',
              icon: Sparkles
            }].map((bonus, index) => {
              const Icon = bonus.icon;
              return <div key={index} className="bg-navy-lighter border border-gold/25 rounded-2xl p-5 hover:border-gold/50 transition-all" data-id="element-195">
                    <div className="w-11 h-11 rounded-xl bg-gold/15 flex items-center justify-center mb-4" data-id="element-196">
                      <Icon className="w-5 h-5 text-gold" data-id="element-197" />
                    </div>
                    <p className="text-[10px] md:text-xs font-black text-gold uppercase tracking-wider mb-1" data-id="element-198">
                      Bonus Premium
                    </p>
                    <h4 className="font-black text-beige text-lg md:text-xl mb-2 leading-tight" data-id="element-199">
                      {bonus.title}
                    </h4>
                    <p className="text-sm text-beige/70 leading-relaxed" data-id="element-200">
                      {bonus.description}
                    </p>
                  </div>;
            })}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}